import { useMutation } from '@tanstack/react-query';
import { CALCULATIONS_MUTATION_KEY } from 'services/calculations/mutationKey';

import { RevenuePlanApi } from '../revenuePlan.api';

export const useGetAllProductsCalculationsRevenue = () => {
  return useMutation({
    mutationKey: CALCULATIONS_MUTATION_KEY,
    mutationFn: RevenuePlanApi.getAllProductsCalculations,
  });
};
